import React from 'react';
import { useLocation, Route, Routes, Navigate } from 'react-router-dom';
// reactstrap components
import { Container, Row } from 'reactstrap';
import LoginFooter from '../components/Footers/LoginFooter';

import routes from 'routes.js';

const Auth = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.body.classList.add('bg-default');
    return () => {
      document.body.classList.remove('bg-default');
    };
  }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      // console.log('sdsd', key, prop.layout);
      if (prop.layout === '/auth') {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };
  // console.log('sdsdsd');
  return (
    <>
      <div className='main-content' ref={mainContent}>
        {/* <AuthNavbar /> */}
        <div className='header bg-danger py-7'>
          {/* <Container>
            <div className="header-body text-center mb-7">
              <Row className="justify-content-center">
                <Col lg="5" md="6">
                  <h2 className="text-xl text-lg">Welcome to</h2>
                  <h1
                    className="text-white"
                    style={{ fontWeight: "bolder", fontSize: "32px" }}
                  >
                    Prairieview Elementary
                  </h1>
                </Col>
              </Row>
            </div>
          </Container> */}
          {/* <Row className="align-items-center justify-content-center mb-4">
            <Col xs="auto" className="px-2">
              <img
                width={"250px"}
                src={logo}
                className="mx-auto d-block"
                alt=""
              />
            </Col>
          </Row> */}
          <div className='separator separator-bottom separator-skew zindex-100'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              preserveAspectRatio='none'
              version='1.1'
              viewBox='0 0 2560 100'
              x='0'
              y='0'
            >
              <polygon
                className='fill-default'
                points='2560 0 2560 100 0 100'
              />
            </svg>
          </div>
        </div>
        {/* Page content */}
        <Container className='mt--8 pb-5'>
          <Row className='justify-content-center'>
            <Routes>
              {getRoutes(routes)}
              <Route path='*' element={<Navigate to='/auth/login' replace />} />
            </Routes>
          </Row>
        </Container>
      </div>
      <div className='p-3' >
        <LoginFooter />
      </div>
    </>
  );
};

export default Auth;
